export default __webpack_public_path__ + "assets/images/46c90556da574f3c56a5b1aea3767b38.png";